module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/btn_ticketshop-afa330f487b3737e706291fb69826caa.png";